<script setup lang="ts">
/**
 * UI-kit component
 * Category: Typography
 * Name: 'Body 3/Regular'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=216-126914&m=dev'
*/

defineOptions({
  name: 'TextTertiary',
})

withDefaults(defineProps<TextTertiaryProps>(), {
  is: 'div',
})

interface TextTertiaryProps {
  is?: 'div' | 'p' | 'span'
}
</script>

<template>
  <component
    :is="is"
    class="p-text-tertiary"
  >
    <slot />
  </component>
</template>

<style scoped lang="scss" src="@scss/components/UI/Typography/TextTertiary.scss" />
